export default "__VITE_ASSET__BHxmJVo___"